const EditableActions = {
    SET_EDIT_LINE: 'EDITABLE_SET_EDIT_LINE',
    CLEAR_EDIT_LINE: 'EDITABLE_CLEAR_EDIT_LINE',
    EDIT_PREV_LINE: 'EDITABLE_EDIT_PREV_LINE',
    EDIT_NEXT_LINE: 'EDITABLE_EDIT_NEXT_LINE',
    SET_FOCUSED_ELEMENT: 'EDITABLE_SET_FOCUSED_ELEMENT',
    SET_ITEMS: 'EDITABLE_SET_ITEMS',
    SET_ITEM: 'EDITABLE_SET_ITEM',
    ADD_ITEM: 'EDITABLE_ADD_ITEM',
    ADD_ITEMS: 'EDITABLE_ADD_ITEMS',
    REMOVE_ITEM: 'EDITABLE_REMOVE_ITEM',
    RESET_TABLE: 'EDITABLE_RESET_TABLE',
    SET_FORM_REF: "EDITABLE_SET_FORM_REF",
    SET_VOID: "EDITABLE_SET_VOID",
    SET_FOCUS_KEY: 'EDITABLE_SET_FOCUS_KEY',
    SET_LINKED_ITEMS: 'EDITABLE_SET_LINKED_ITEMS',
    AFTER_SET_FIELDS_VALUE: 'EDITABLE_AFTER_SET_FIELDS_VALUE',
    SET_ACTIVE_TABLE: 'EDITABLE_SET_ACTIVE_TABLE',

    SET_PAGINATION: "EDITABLE_SET_PAGINATION",

    ClEAR_ALL_EDIT_LINE: "EDITABLE_CLEAR_ALL_EDIT_LINE",
    SET_SORTABLE_WIDTHS: 'EDITABLE_SET_SORTABLE_WIDTHS',
    EDITABLE_SET_IS_AUTOFILL: "EDITABLE_SET_IS_AUTOFILL",
    ADD_BATCH_CUSTOM_FIELDS: "EDITABLE_ADD_BATCH_CUSTOM_FIELDS",

    clearAllEditLine: () => ({
        type: EditableActions.ClEAR_ALL_EDIT_LINE,
    }),

    setPagination: (name, pagination) => ({
        type: EditableActions.SET_PAGINATION,
        name,
        pagination,
    }),

    setSortableWidths: widths => ({
        type: EditableActions.SET_SORTABLE_WIDTHS,
        widths,
    }),

    setFormRef: (name, formRef) => ({
        type: EditableActions.SET_FORM_REF,
        name,
        formRef,
    }),

    setVoid: (name, isVoid) => ({
        type: EditableActions.SET_VOID,
        name,
        isVoid,
    }),

    setEditLine: (name, key) => ({
        type: EditableActions.SET_EDIT_LINE,
        name,
        key,
    }),

    clearEditLine: name => ({
        type: EditableActions.CLEAR_EDIT_LINE,
        name,
    }),

    editPrevLine: name => ({
        type: EditableActions.EDIT_PREV_LINE,
        name,
    }),

    editNextLine: name => ({
        type: EditableActions.EDIT_NEXT_LINE,
        name,
    }),

    setFocusedElement: (name, element) => ({
        type: EditableActions.SET_FOCUSED_ELEMENT,
        name,
        element,
    }),

    setFocus: (name, focusKey) => ({
        type: EditableActions.SET_FOCUS_KEY,
        name,
        focusKey,
    }),

    setItems: (name, items, isVoid = undefined) => ({
        type: EditableActions.SET_ITEMS,
        name,
        items: items || [],
        isVoid,
    }),

    setItem: (name, item, params = {}) => ({
        type: EditableActions.SET_ITEM,
        name,
        item,
        params,
    }),

    addItem: (name, item, editItem = false, params = {}, index = undefined) => ({
        type: EditableActions.ADD_ITEM,
        name,
        item,
        editItem,
        params,
        index,
    }),

    addItems: (name, items) => ({
        type: EditableActions.ADD_ITEMS,
        name,
        items,
    }),

    addChild: (name, parentKey, item, editItem = false, params = {}) => ({
        type: EditableActions.ADD_ITEM,
        name,
        parentKey,
        item,
        editItem,
        params,
    }),

    removeItem: (name, key) => ({
        type: EditableActions.REMOVE_ITEM,
        name,
        key,
    }),

    resetTable: name => ({
        type: EditableActions.RESET_TABLE,
        name,
    }),

    setLinkedItems: (name, items, keysToRemove) => ({
        type: EditableActions.SET_LINKED_ITEMS,
        name,
        items,
        keysToRemove,
    }),

    afterSetFieldsValue: name => ({
        type: EditableActions.AFTER_SET_FIELDS_VALUE,
        name,
    }),

    setActiveTable: name => ({
        type: EditableActions.SET_ACTIVE_TABLE,
        name,
    }),

    // applicable for tables with autofill (eg: payment_deposit_items)
    setIsAutofill: (name = "", value = true) => ({
        type: EditableActions.EDITABLE_SET_IS_AUTOFILL,
        name,
        value,
    }),

    withName: name => ({
        setFormRef: formRef => EditableActions.setFormRef(name, formRef),
        setVoid: isVoid => EditableActions.setVoid(name, isVoid),
        setItems: (items, isVoid = undefined) => EditableActions.setItems(name, items, isVoid),

        setEditLine: key => EditableActions.setEditLine(name, key),
        clearEditLine: () => EditableActions.clearEditLine(name),
        editPrevLine: () => EditableActions.editPrevLine(name),
        editNextLine: () => EditableActions.editNextLine(name),
        setFocusedElement: element => EditableActions.setFocusedElement(name, element),
        setFocus: element => EditableActions.setFocus(name, element),
        setItem: (item, params = {}) => EditableActions.setItem(name, item, params),
        addItem: (item, editItem = false, params = {}, index = undefined) => (
            EditableActions.addItem(name, item, editItem, params, index)
        ),
        addChild: (parentKey, item, editItem = false, params = {}) => (
            EditableActions.addChild(name, parentKey, item, editItem, params)
        ),
        addItems: items => EditableActions.addItems(name, items),
        removeItem: key => EditableActions.removeItem(name, key),
        resetTable: () => EditableActions.resetTable(name),
        setLinkedItems: (items, keysToRemove) => EditableActions.setLinkedItems(name, items, keysToRemove),
        setIsAutofill: value => EditableActions.setIsAutofill(name, value),
        setPagination: pagination => EditableActions.setPagination(name, pagination),
        // setActiveTable: () => EditableActions.setActiveTable(name),
    }),
};
export default EditableActions;
